import React, { Dispatch, SetStateAction } from 'react';

export const SearchContext = React.createContext<{
  searchTerm: string,
  setSearchTerm: Dispatch<SetStateAction<string>>}>({
    searchTerm: '',
    setSearchTerm: () => null
  });
